import { render, staticRenderFns } from "./treegrid.vue?vue&type=template&id=28cd5ffe&scoped=true&"
import script from "./treegrid.vue?vue&type=script&lang=js&"
export * from "./treegrid.vue?vue&type=script&lang=js&"
import style0 from "./treegrid.vue?vue&type=style&index=0&id=28cd5ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd5ffe",
  null
  
)

export default component.exports